import { StyleSheet, css } from 'aphrodite';
import PropTypes from 'prop-types';
import React from 'react';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import { getTestimonials } from '../../actions/applicationData';
import { updateAppState } from '../../actions/applicationState';
import { Theme } from '../../config/theme';

let styles;

export default class OurCommunity extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeTestimonial: 1,
      readMoreOpen: false,
    };
    this.handleReadMoreToggle = this.handleReadMoreToggle.bind(this);
    this.setSlide = this.setSlide.bind(this);
  }

  componentWillMount() {
    // Skip API calls during react-snap pre-rendering
    if (navigator.userAgent === 'ReactSnap') {
      this.setState({
        loaded: true,
        testimonials: [],
      });
      return;
    }

    this.fetchTestimonials();
  }

  setSlide(slide, id) {
    this.setState(
      {
        activeTestimonial: id,
      },
      () => {
        this.slider.slickGoTo(slide);
      },
    );
  }

  handleReadMoreToggle(e) {
    e.preventDefault();
    this.setState({
      readMoreOpen: !this.state.readMoreOpen,
    });
  }

  fetchTestimonials() {
    this.props
      .dispatch(
        updateAppState({
          loading: true,
        }),
      )
      .then(() => {
        this.props.dispatch(getTestimonials()).then(
          response => {
            this.setState(
              {
                testimonials: response,
                loaded: true,
              },
              () => {
                setTimeout(() => {
                  this.slider.innerSlider.onWindowResized();
                }, 0);
              },
            );

            this.props.dispatch(
              updateAppState({
                loading: false,
              }),
            );
          },
          err => {
            console.log(err); // eslint-disable-line no-console
            this.props.dispatch(
              updateAppState({
                loading: false,
              }),
            );
            this.props.history.push('/404');
          },
        );
      });
  }

  render() {
    const buttonText = this.state.readMoreOpen ? 'Read Less' : 'Find Out More';

    const sliderSettings = {
      dots: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 15000,
      afterChange: index => {
        this.setSlide(index, this.state.testimonials[index].id);
      },
    };

    return (
      <div className={css(styles.section)}>
        <div className={css(styles.container)}>
          <div className={css(styles.column)}>
            <h2 className={css(styles.heading)}>Our Collective Impact</h2>
            <p className={css(styles.paragraph)}>
              The Dog Share Collective provides practical, economical and sustainable canine
              companionship solutions for NZ dogs.
            </p>
            <p className={css(styles.paragraph)}>
              By providing innovative solutions to pressing social problems for dogs, and the people
              who love them, The Dog Share Collective builds a membership, creates a profit, and
              makes a difference by giving back to the wider dog community.
            </p>
            {this.state.readMoreOpen ? (
              <p className={css(styles.paragraph)}>
                As a social enterprise, The Dog Share Collective difference = $1 of every membership
                fee being given to a NZ dog charity of our {"member's"} choosing through our
                charitable trust called The UnderDogs Foundation (CC54581). Called our{' '}
                {'Impact Partners'}, these proven dog charities provide invaluable service to our
                communities.
                <br />
                <br />
                By giving them a leg up, we provide maximum support to the widest NZ dog community
                possible and, together, we become part of something truly great.
              </p>
            ) : null}
            <button className={css(styles.more)} onClick={this.handleReadMoreToggle}>
              {buttonText}
            </button>
          </div>

          {this.state.testimonials ? (
            <div className={css(styles.column, styles.column_testimonials)}>
              <div className={css(styles.slides)}>
                <Slider
                  {...sliderSettings}
                  ref={slider => {
                    this.slider = slider;
                  }}
                >
                  {this.state.testimonials.map(testimonial => (
                    <div
                      key={testimonial.id}
                      className={css(
                        styles.slide,
                        testimonial.id === this.state.activeTestimonial
                          ? styles.slide_active
                          : null,
                      )}
                    >
                      <img
                        className={css(styles.photo)}
                        src={testimonial.image}
                        alt={testimonial.name}
                      />
                      <div className={css(styles.testimonial)}>{testimonial.copy}</div>
                      <div className={css(styles.author)}>
                        {testimonial.name}, {testimonial.location}
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
              <div className={css(styles.indicators)}>
                {this.state.testimonials.map((testimonial, index) => (
                  <div
                    onClick={() => this.setSlide(index, testimonial.id)}
                    role="button"
                    tabIndex={0}
                    key={testimonial.id}
                    className={css(
                      styles.indicator,
                      testimonial.id === this.state.activeTestimonial
                        ? styles.indicator_active
                        : null,
                    )}
                  />
                ))}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

OurCommunity.defaultProps = {
  history: () => {},
};

OurCommunity.propTypes = {
  history: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
};

styles = StyleSheet.create({
  section: {
    padding: '108px 0',
    backgroundColor: '#fff',

    [Theme.mobile_query]: {
      height: 'auto',
      padding: '40px 0 50px',
      textAlign: 'center',
    },
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '100%',
    maxWidth: '100vw',
    width: Theme.container_width,
    margin: '0 auto',
    padding: '0 15px',

    [Theme.mobile_query]: {
      display: 'block',
      width: '100%',
    },
  },
  heading: {
    width: 410,
    marginBottom: 40,
    fontFamily: Theme.font_family_heading,
    fontSize: 40,
    fontWeight: Theme.font_weight_heading,
    color: '#020440',

    [Theme.mobile_query]: {
      width: 'auto',
      fontSize: 30,
    },
  },
  paragraph: {
    width: 410,
    marginBottom: '1em',
    fontFamily: Theme.font_family_primary,
    fontSize: 15,
    fontWeight: 500,
    lineHeight: '1.6',
    color: '#828282',

    [Theme.mobile_query]: {
      width: 'auto',
      padding: '0 15px',
    },
  },
  more: {
    display: 'inline-block',
    marginTop: 30,
    fontFamily: Theme.font_family_secondary,
    color: '#39b4d6',
    textTransform: 'uppercase',
    lineHeight: 1.4,
    letterSpacing: 2,
    fontSize: 15,
    border: 'none',
    borderBottom: '2px solid #39b4d6',
    backgroundColor: 'transparent',
    outline: 'none',
    cursor: 'pointer',
    [Theme.mobile_query]: {
      marginTop: 0,
      marginBottom: 30,
    },
  },
  column_testimonials: {
    marginLeft: 80,
    // marginTop: 50,
    textAlign: 'center',

    [Theme.mobile_query]: {
      width: 'auto',
      marginLeft: 0,
      marginTop: 30,
    },
  },
  slides: {
    width: 571,

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  slide: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  photo: {
    height: 120,
    width: 120,
    marginBottom: 21,
    borderRadius: '50%',
  },
  testimonial: {
    marginBottom: 40,
    fontSize: 20,
    fontWeight: 500,
    fontFamily: Theme.font_family_primary,
    color: '#000e1f',
  },
  author: {
    fontSize: 14,
    fontFamily: Theme.font_family_primary,
    color: '#828282',
  },
  indicators: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 40,
  },
  indicator: {
    height: 14,
    width: 14,
    margin: '0 11px',
    borderRadius: '50%',
    backgroundColor: '#fff',
    border: 'solid 1px #d0d0d0',
    cursor: 'pointer',
    outline: 'none',
  },
  indicator_active: {
    borderColor: Theme.primary,
    backgroundColor: Theme.primary,
  },
});



// WEBPACK FOOTER //
// ./src/components/Community/index.js